import { Routes } from '@angular/router';

export const ProductsMarketPlaceRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./all-products/products/products.component').then(
        m => m.ProductsComponent
      ),
  },
];
